import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $acceptButton: this.el.querySelector('.confirmation-modal__accept'),
      $doNotAcceptButton: this.el.querySelector(
        '.confirmation-modal__do-not-accept'
      )
    };
  }

  addListeners() {
    document.addEventListener('click', this.handleLinkClick.bind(this));
    this.dom.$acceptButton.addEventListener('click', this.accept.bind(this));
    this.dom.$doNotAcceptButton.addEventListener(
      'click',
      this.doNotAccept.bind(this)
    );
  }

  handleLinkClick(event) {
    const target = event.target.closest('a');

    if (
      target &&
      target.tagName === 'A' &&
      target.href &&
      target.target.toLowerCase().startsWith('openmodal')
    ) {
      event.preventDefault();
      this.redirectUrl = target.href;
      this.showModal();
    }
  }

  accept() {
    this.handleContinueClick();
    this.hideModal();
  }

  doNotAccept() {
    this.hideModal();
  }

  handleContinueClick() {
    if (this.redirectUrl) {
      window.open(this.redirectUrl, '_self', 'noopener,noreferrer');
    }
  }

  showModal() {
    this.el.style.display = 'flex';
    this.el.setAttribute('aria-hidden', 'false');
  }

  hideModal() {
    this.el.style.display = 'none';
    this.el.setAttribute('aria-hidden', 'true');
  }
}

export default Module;
